<template>
  <div>
    <top-img-temp :imgUrl="topImg" :cName="cName" :e-name="eName"></top-img-temp>
    <div class="section2">
      <div class="cont">
        <p>{{isChinese ? '新闻中心' : 'news Center'}} <span class="p1style">/{{isChinese ? dataObj.title : dataObj.titleEn}}</span></p>
        <div class="contIner">
          <p class="p2style">{{isChinese ? dataObj.title : dataObj.titleEn}}</p>
          <p class="p1style">{{isChinese ? '发布时间' : 'Time'}}：{{dataObj.activityTime}}</p>
          <div class="heng"></div>
          <p class="basep">{{dataObj.p1}}</p>
          <div class="imgbox">
            <div v-html="isChinese ? dataObj.content : dataObj.contentEn "></div>
            <!--<img :src="dataObj.imgurl" alt="">-->
          </div>
          <!--<p class="basep">{{dataObj.p2}}</p>-->

        </div>

      </div>
    </div>
    <div>

    </div>
  </div>
</template>

<script>

  import topImgTemp from '../baseTemp/topImgTemp'
  export default {
    name: "newsDetail",
    data() {
      return {
        isChinese: undefined,
        id: '',
        topImg: require('../../../static/images/base/XWZX-35.jpg'),
        cName: '新闻中心',
        eName: 'News Center',
        dataObj: {}
      }
    },
    created() {
      this.id = window.location.href.split("id=")[1]
      this.getAllDetalsNewsInfo(this.id)
    this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;

    },
    computed: {
      setCAE() {
        return this.$store.state.cAeSatus;
      }
    },
    watch: {
      //监听路由变化
      setCAE(newVal) {
        this.isChinese = newVal === 1 ? true : false;
      }
    },

    components: {topImgTemp},
    methods: {
      getAllDetalsNewsInfo (id) {
        this.$http
          .get("/jishi/api/activity/info/" + id)
          .then(
            function (res) {
              if (res && res.data.code === 0) {
                let resdata = res.data.data
                this.dataObj = resdata
                // let resdata = res.data.page
                // this.newslist = resdata.list
              }
            }.bind(this)
          )

      }
    }
  }
</script>

<style scoped>

  img {
    width: 100%;
  }
  .section2 {
    width: 100%;
    margin-top: 6vw;
    color: #7c7c7c;
  }
  .cont {
    width: 60%;
    margin: 0 auto;
  }
  .contIner {
    background: white;
    box-shadow: 1px 0px 5px #dfdfdf;
    padding: 20px 20px 40px 20px;
  }
  .imgbox {
    width: 40vw;
    margin: 0 auto;
    margin: 5vw auto;
  }

  .p1style {
    font-size: 1.4rem;
    color: #474747;
  }
  .p2style {
    font-size: 1.8rem;
    color: black;
  }
  .heng {
    height: 1px;
    background: #868686;
  }
  .basep {
    line-height: 20px;
    font-size: 1.3rem;
  }
@media(max-width: 800px){
   .cont {
    width: 95%;
  }
    .imgbox {
    width: 80vw;
  }
  .imgbox>>>img{
    width: 100%;
  }
}


</style>
<style  scoped>
    .imgbox>>>*{
      font-size: 15px;
      line-height: 27px;
    }
</style>



// WEBPACK FOOTER //
// src/components/News2/newsDetail.vue